/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Chunk } from './Chunk';
import {
    ChunkFromJSON,
    ChunkFromJSONTyped,
    ChunkToJSON,
} from './Chunk';

/**
 * 
 * @export
 * @interface ChunkEditRequest
 */
export interface ChunkEditRequest {
    /**
     * 
     * @type {string}
     * @memberof ChunkEditRequest
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof ChunkEditRequest
     */
    chunkId: string;
    /**
     * 
     * @type {string}
     * @memberof ChunkEditRequest
     */
    fieldName: string;
    /**
     * 
     * @type {Chunk}
     * @memberof ChunkEditRequest
     */
    newValue: Chunk;
}

/**
 * Check if a given object implements the ChunkEditRequest interface.
 */
export function instanceOfChunkEditRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "chunkId" in value;
    isInstance = isInstance && "fieldName" in value;
    isInstance = isInstance && "newValue" in value;

    return isInstance;
}

export function ChunkEditRequestFromJSON(json: any): ChunkEditRequest {
    return ChunkEditRequestFromJSONTyped(json, false);
}

export function ChunkEditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunkEditRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'chunkId': json['chunkId'],
        'fieldName': json['fieldName'],
        'newValue': ChunkFromJSON(json['newValue']),
    };
}

export function ChunkEditRequestToJSON(value?: ChunkEditRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentId': value.documentId,
        'chunkId': value.chunkId,
        'fieldName': value.fieldName,
        'newValue': ChunkToJSON(value.newValue),
    };
}

